import { FaArrowLeft } from "react-icons/fa";
import Footer from "./Footer";
import Header from "./header";
import { Helmet } from "react-helmet-async";

const styles = {
  pageWrapper: {
    display: "flex",
    flexDirection: "column",
    minHeight: "100vh",
    width: "100%",
    fontFamily: "'Plus Jakarta Sans', sans-serif",
    background: "#FFFFFF",
    overflowX: "hidden",
  },
  container: {
    width: "85%",
    maxWidth: "1400px",
    margin: "0 auto",
    padding: "40px 0",
    flex: "1",
    marginTop: "50px",
  },
  breadcrumb: {
    display: "flex",
    alignItems: "center",
    gap: "10px",
    fontSize: "14px",
    color: "#64748B",
    marginBottom: "25px",
  },
  backBtn: {
    background: "white",
    border: "1px solid #E2E8F0",
    padding: "8px 14px",
    borderRadius: "8px",
    cursor: "pointer",
    display: "flex",
    alignItems: "center",
    gap: "8px",
    fontWeight: "600",
  },
};

const AboutUs = ({ onBack }) => {
  return (
    <>
      <Helmet>
        <title>About Us | CGRMART</title>

        <meta
          name="description"
          content="Learn about CGRMART and Tucker Motors, leaders in EV charging solutions in India. Discover our mission, vision, and innovation in electric vehicle infrastructure."
        />
        
        <meta
          name="keywords"
          content="About CGRMART, Tucker Motors, EV charging company India, electric vehicle infrastructure, EV chargers manufacturer"
        />

        <meta name="robots" content="index, follow" />

        {/* Open Graph */}
        <meta property="og:title" content="About Us | CGRMART" />
        <meta
          property="og:description"
          content="Discover CGRMART's journey, mission, and expertise in EV charging solutions."
        />
        <meta property="og:type" content="website" />
        <meta property="og:url" content="https://cgrmart.com/aboutus" />

        {/* Twitter */}
        <meta name="twitter:title" content="About Us | CGRMART" />
        <meta
          name="twitter:description"
          content="CGRMART - EV charging innovation and sustainable future."
        />

        {/* Canonical */}
        <link rel="canonical" href="https://cgrmart.com/aboutus" />
      </Helmet>

      <Header />

      <div style={styles.pageWrapper}>
        <div style={styles.container}>
          {/* Title */}
          <h1
            style={{
              fontSize: "36px",
              fontWeight: "800",
              marginBottom: "20px",
            }}
          >
            Our Company
          </h1>

          {/* About Section */}
          <div
            style={{
              display: "grid",
              gridTemplateColumns: "1fr 1fr",
              gap: "30px",
              alignItems: "center",
              margin: "0 auto 40px",
              marginBottom: "40px",
            }}
          >
            <div>
              <p style={{ color: "#64748B", lineHeight: "1.7" }}>
                Tucker Motors Private Limited is a leading manufacturer in
                designing and manufacturing EV charging stations and providing a
                complete ecosystem for E-mobility. All products are NABL & ISO
                certified and made in India.
              </p>

              <p
                style={{
                  color: "#64748B",
                  lineHeight: "1.7",
                  marginTop: "15px",
                }}
              >
                With a strong technical team and R&D center in Madurai, we
                deliver advanced engineering solutions with modern hardware and
                software.
              </p>
            </div>

            <img
              src="https://tuckermotors.com/images/misc/s1.jpg"
              alt="About"
              style={{ width: "100%", borderRadius: "12px" }}
            />
          </div>

          {/* Services */}
          <h2
            style={{
              fontSize: "24px",
              fontWeight: "700",
              marginBottom: "10px",
            }}
          >
            Our Services
          </h2>

          <img
            src="https://tuckermotors.com/images/misc/services-2.webp"
            alt="Services"
            style={{
              width: "100%",
              borderRadius: "12px",
              marginBottom: "20px",
              width: "50%",
              borderRadius: "16px",
              margin: "0 auto 40px",
              display: "block",
            }}
          />

          <ul
            style={{
              color: "#475569",
              lineHeight: "1.8",
              marginBottom: "40px",
            }}
          >
            <li>
              <b>Maintenance & Support:</b> Reliable EV charging support
            </li>
            <li>
              <b>Network Integration:</b> Smart monitoring & analytics
            </li>
            <li>
              <b>Installation:</b> End-to-end charger setup
            </li>
          </ul>

          {/* Mission */}
          <h2
            style={{
              fontSize: "24px",
              fontWeight: "700",
              marginBottom: "10px",
            }}
          >
            Our Mission
          </h2>

          <ul
            style={{
              color: "#475569",
              lineHeight: "1.8",
              marginBottom: "40px",
            }}
          >
            <li>Seamless charging access</li>
            <li>Better user experience</li>
            <li>Innovation & sustainability</li>
            <li>Greener future</li>
          </ul>

          {/* Vision */}
          <h2
            style={{
              fontSize: "24px",
              fontWeight: "700",
              marginBottom: "10px",
            }}
          >
            Our Vision
          </h2>

          <p
            style={{
              color: "#64748B",
              lineHeight: "1.7",
              marginBottom: "40px",
            }}
          >
            To make EV charging effortless, reliable, and accessible while
            supporting a sustainable future.
          </p>

          {/* Journey */}
          <h2
            style={{
              fontSize: "24px",
              fontWeight: "700",
              marginBottom: "10px",
            }}
          >
            Our Journey
          </h2>

          <ul style={{ color: "#475569", lineHeight: "1.8" }}>
            <li>2017 - EV R&D Started</li>
            <li>2018 - EV Manufacturing Started</li>
            <li>2019 - Charger R&D Started</li>
            <li>2020 - World’s 1st OCPP 3.3kW AC Charger</li>
            <li>2021 - DC Fast Charger Sales</li>
            <li>2023 - High Power Charger R&D</li>
            <li>2024 - India’s 1st Compact 3.3kW Charger</li>
          </ul>

          {/* Bottom Image */}
          <img
            src="https://tuckermotors.com/images/misc/s2.jpg"
            alt="Journey"
            style={{
              width: "100%",
              borderRadius: "16px",
              marginTop: "40px",
              width: "50%",
              borderRadius: "16px",
              margin: "0 auto 40px",
              display: "block",
            }}
          />
        </div>

        <Footer />
      </div>
    </>
  );
};

export default AboutUs;
